export const getFileType = (filename) => {
  if (!filename) return 'unknown';
  const ext = filename.split('.').pop().toLowerCase();
  
  const typeMap = {
    // Images
    jpg: 'image', jpeg: 'image', png: 'image', gif: 'image', 
    bmp: 'image', webp: 'image', svg: 'image',
    
    // Documents
    pdf: 'pdf',
    doc: 'document', docx: 'document',
    
    // Spreadsheets
    xlsx: 'spreadsheet', xls: 'spreadsheet', csv: 'spreadsheet',
    
    // Text
    txt: 'text', md: 'text', json: 'text',
    
    // Code
    js: 'code', jsx: 'code', ts: 'code', tsx: 'code', 
    css: 'code', html: 'code', xml: 'code'
  };
  
  return typeMap[ext] || 'unsupported';
};

export const formatFileSize = (bytes) => {
  if (!bytes) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};